import keyMirror from 'keymirror';

export const gameActionTypes = keyMirror({
	GET_GAME_DATA_REQUEST: null,
	GET_GAME_DATA_SUCCESS: null,
	GET_GAME_DATA_ERROR: null,
	FINISH_GAME_REQUEST: null,
	FINISH_GAME_SUCCESS: null,
	FINISH_GAME_ERROR: null,
	CLEAR_GAME_STATE: null,
	SET_CURRENT_LEVEL: null,
});

export const GAME_TYPES = {
	BOUNCY_SUMS_GAME: 'BouncySumsGame',
	LANE_CHOOSER_GAME: 'CanoeGame',
	LETTER_PARTY_GAME: 'LetterpartyGame',
	TIME_GAME: 'TimeGame',
} as const;
